import { useEffect } from 'react';
import { Marque } from '../Marque';
import type { CheminPublic } from './chemins';
import { Confidentialite } from './Confidentialite';
import { MentionsLegales } from './MentionsLegales';
import './PagePublique.css';

/**
 * Les pages « Confidentialité » et « Mentions légales » (chantier comptes, ticket 05) : lisibles
 * par tout le monde, connecté ou non, au téléphone comme à l'ordinateur. Pas de planche : faites
 * dans le style de l'écran de connexion (le papier, la marque, une carte blanche posée), avec
 * une colonne de lecture étroite.
 *
 * Elles s'ouvrent par leur adresse (un lien simple depuis la connexion et l'inscription) : App
 * les rend avant de regarder la session, et le serveur les sert par le repli de page unique.
 */

const PAGES_PUBLIQUES = {
  '/confidentialite': { titre: 'Confidentialité', Contenu: Confidentialite },
  '/mentions-legales': { titre: 'Mentions légales', Contenu: MentionsLegales },
} as const satisfies Record<CheminPublic, unknown>;

export function PagePublique({ chemin }: { chemin: CheminPublic }) {
  const { titre, Contenu } = PAGES_PUBLIQUES[chemin];
  const autre = chemin === '/confidentialite' ? '/mentions-legales' : '/confidentialite';

  useEffect(() => {
    const avant = document.title;
    document.title = `${titre} · Nextilt`;
    return () => {
      document.title = avant;
    };
  }, [titre]);

  return (
    <div className="page-publique">
      <header className="page-publique-tete">
        {/* La marque mène au même endroit que le lien écrit : un seul arrêt au clavier. */}
        <a href="/" className="page-publique-marque" tabIndex={-1} aria-hidden="true">
          <Marque taille={34} />
        </a>
        <a href="/" className="page-publique-retour">
          Revenir à Nextilt
        </a>
      </header>

      <main className="page-publique-carte">
        <h1 className="page-publique-titre">{titre}</h1>
        <Contenu />
      </main>

      <footer className="page-publique-pied">
        <a href={autre}>{PAGES_PUBLIQUES[autre].titre}</a>
      </footer>
    </div>
  );
}
